// v18m 자연스러움 파이프라인 공용 수학 유틸
// (kemix-engine blendshape-player-natural.html 의 gaussianFilter1d / smoothstep 포팅)

export const clamp01 = (x: number): number => (x < 0 ? 0 : x > 1 ? 1 : x);

/** cubic Hermite smoothstep — edge0 미만 0, edge1 초과 1 */
export const smoothstep = (edge0: number, edge1: number, x: number): number => {
  const t = clamp01((x - edge0) / (edge1 - edge0));
  return t * t * (3 - 2 * t);
};

/** 시간 상수 tau(초) 기반 EMA 계수. dt<=0 이면 즉시 수렴(1) */
export const emaAlpha = (dt: number, tau: number): number =>
  dt > 0 ? 1 - Math.exp(-dt / tau) : 1;

/**
 * 제로페이즈(중심) 가우시안 1D 필터. 경계는 edge-clamp(끝값 반복).
 * radius = max(1, ceil(sigma*4))
 */
export function gaussianFilter1d(arr: ArrayLike<number>, sigma: number): Float32Array {
  const T = arr.length;
  const out = new Float32Array(T);
  if (sigma <= 0) {
    for (let t = 0; t < T; t++) out[t] = arr[t];
    return out;
  }
  const radius = Math.max(1, Math.ceil(sigma * 4));
  const kernel = new Float32Array(2 * radius + 1);
  let s = 0;
  for (let i = -radius; i <= radius; i++) {
    const v = Math.exp(-(i * i) / (2 * sigma * sigma));
    kernel[i + radius] = v;
    s += v;
  }
  for (let i = 0; i < kernel.length; i++) kernel[i] /= s;
  for (let t = 0; t < T; t++) {
    let sum = 0;
    for (let k = -radius; k <= radius; k++) {
      let idx = t + k;
      if (idx < 0) idx = 0;
      else if (idx >= T) idx = T - 1;
      sum += arr[idx] * kernel[k + radius];
    }
    out[t] = sum;
  }
  return out;
}
